import { render, staticRenderFns } from "./FooterAmount.vue?vue&type=template&id=230fd7c4&"
import script from "./FooterAmount.vue?vue&type=script&lang=js&"
export * from "./FooterAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports